<template>
  <div>
    <div class="container_wrap">
      <div class="container_right_hotrecommend">
        <div class="container_right_hotrecommend_icon">剧组动态</div>
        <div
          class="container_right_hotrecommend_img"
          @click="imgClickFun()"
        >
          <img :src="imgTargeturl" />
        </div>
        <div class="container_right_hotrecommend_font">
          <ul>
            <template v-for="(item, index) in newsListDataArr">
              <li :key="index" v-rblink="{name:'CmsDetail',query:{id:item.id}}">{{ item.title }}</li>
            </template>
          </ul>
        </div>
      </div>
      <!-- <div class="container_right_doublecode">
        <img :src="codedescAndpic.RecommendCode&&codedescAndpic.RecommendCode.length>0?codedescAndpic.RecommendCode[0].url:''" alt="" class="container_right_doublecode_img">
        <div class="container_right_doublecode_font">
          <div class="container_right_doublecode_font_up">更多精彩内容</div>
          <div class="container_right_doublecode_font_down">
            请关注「{{codedescAndpic?codedescAndpic.RecommendCodeDesc:''}}」
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
//剧组动态
export default {
  name: "CmsCrew",
  data() {
    return {
      newsListDataArr: [],
      imgTargeturl: "",
      imgTargetindex: 0,
      // codedescAndpic: {},
    };
  },
  mounted() {
    this.getnewslistFun();
    //获取首页底部 二维码
    // this.getCmsDetail(328);
  },
  methods: {
    //获取文章详情
    // getCmsDetail(id) {
    //   this.$api.get(
    //     "api/cms/detail",
    //     { id: id },
    //     (res) => {
    //       var codeDetail = res.data.data.extra_data;
    //       if (codeDetail && codeDetail.length > 0) {
    //         codeDetail.some((item) => {
    //           this.codedescAndpic[`${item.field_key}`] = item.value;
    //         });
    //       }
    //       var codedetail =  this.codedescAndpic;
    //       this.codedescAndpic={};
    //       this.codedescAndpic=codedetail;
    //     },
    //     (err) => {
    //       console.log(err);
    //     }
    //   );
    // },
    getnewslistFun() {
      this.$api.get(
        "/api/cms/helpList",
        { cate_id: 161, step: 6 },//161剧组动态cate_id
        (res) => {
          this.newsListDataArr = res.data.list;
          this.newsListDataArr.map((item, index) => {
            if (item.pics.length > 0) {
              this.imgTargeturl = item.pics[0].url;
              this.imgTargetindex = index;
            }
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
    imgClickFun(){
        this.$router.push({name:"CmsDetail",query:{id:this.newsListDataArr[this.imgTargetindex].id}})
    }
  },
};
</script>
<style lang="scss" scoped>
.container_right_hotrecommend {
  width: 306px;
  min-height: 450px;
  background: #fff4ed;
  border-radius: 17px;
  padding-left: 13px;
  padding-right: 11px;
  box-sizing: border-box;
  .container_right_hotrecommend_icon {
    width: 125px;
    height: 55px;
    line-height: 55px;
    background: url("~@/assets/images/listitem/icon-news-list-recommend@2x.png")
      no-repeat;
    background-size: 100% 100%;
    font-size: 20px;
    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
    font-weight: 500;
    color: #000000;
    padding-left: 30px;
    box-sizing: border-box;
  }
  .container_right_hotrecommend_img {
    width: 282px;
    height: 121px;
    border-radius: 12px 12px 4px 4px;
    overflow: hidden;
    &:hover {
      cursor: pointer;
    }
    // background: url("~@/assets/images/listitem/pic-news-recommend@2x.png")
    //   no-repeat center center;
    // background-size: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .container_right_hotrecommend_font {
    width: 267px;
    font-size: 14px;
    
    font-weight: 400;
    color: #000000;
    line-height: 17px;
    margin-top: 23px;
    ul li {
      list-style: disc;
      margin-left: 14px;
      margin-top: 15px;
      &::marker {
        color: #87c5f5;
      }
      &:hover {
        font-weight: bolder;
        cursor: pointer;
      }
    }
  }
}
.container_right_doublecode {
  width: 302px;
  height: 116px;
  background: #f8f8f8;
  border-radius: 20px;
  margin-top: 48px;
  padding: 19px 0 19px 11px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  .container_right_doublecode_img {
    width: 78px;
    height: 78px;
    object-fit: cover;
  }
  .container_right_doublecode_font {
    font-size: 14px;
    
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 5px;
    margin-left: 8px;
    box-sizing: border-box;
    .container_right_doublecode_font_down {
      font-weight: bolder;
    }
  }
}
</style>


// WEBPACK FOOTER //
// CmsCrew.vue?5bb30a92